import { Equipment } from '../types';

export const radioEquipmentDatabase: Equipment[] = [
  // Ubiquiti airFiber
  {
    id: 'ubnt-af11',
    name: 'airFiber 11',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 1299,
    specifications: {
      frequency: '11GHz',
      throughput: '1.4+ Gbps',
      range: '200+ km'
    }
  },
  {
    id: 'ubnt-af5xhd',
    name: 'airFiber 5XHD',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 799,
    specifications: {
      frequency: '5GHz',
      throughput: '1+ Gbps',
      range: '100+ km'
    }
  },
  {
    id: 'ubnt-af24',
    name: 'airFiber 24',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 1899,
    specifications: {
      frequency: '24GHz',
      throughput: '2+ Gbps',
      range: '20+ km'
    }
  },
  {
    id: 'ubnt-af60',
    name: 'airFiber 60',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 2499,
    specifications: {
      frequency: '60GHz',
      throughput: '2+ Gbps',
      range: '5+ km'
    }
  },

  // Cambium PTP Radios
  {
    id: 'cambium-ptp670',
    name: 'PTP 670',
    type: 'radio-dish',
    manufacturer: 'cambium',
    price: 1599,
    specifications: {
      frequency: '5/6GHz',
      throughput: '650 Mbps',
      range: '100+ km'
    }
  },
  {
    id: 'cambium-ptp820',
    name: 'PTP 820',
    type: 'radio-dish',
    manufacturer: 'cambium',
    price: 3499,
    specifications: {
      frequency: '6-42GHz',
      throughput: '750 Mbps',
      range: '100+ km'
    }
  },

  // Mimosa Prism
  {
    id: 'mimosa-prism',
    name: 'Prism 5',
    type: 'sector-antenna',
    manufacturer: 'mimosa',
    price: 999,
    specifications: {
      frequency: '5GHz',
      throughput: '500+ Mbps',
      clients: '100+'
    }
  },
  {
    id: 'mimosa-b5',
    name: 'B5',
    type: 'radio-dish',
    manufacturer: 'mimosa',
    price: 649,
    specifications: {
      frequency: '5GHz',
      throughput: '1+ Gbps',
      range: '50+ km'
    }
  }
];













